import { Col, Row } from 'react-bootstrap';

const ComingSoon = () => {
  return (
    <Row className="flex-center content-min-h pb-9">
      <Col xs={12} xxl={10}>
        <Row className="align-items-xl-center g-2">
          <Col xs={12} xl={6} className="order-xl-1">
            <div className="d-flex flex-center"></div>
          </Col>
          <Col xs={12} xl={6}>
            <div className="d-flex justify-content-center mt-xl-15">
              <div className="text-container text-center text-xl-start">
                <h2 className="text-body-secondary fs-xl-6 mb-3">
                  Something in the way!
                </h2>
                <p className="mb-6 w-xxl-75">
                  Be the first to know about upcoming features.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ComingSoon;
